import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import User from '@/utils/apiModules/User'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: Cookies.get('token') || '',
    menu: [], // 菜单
    cachedViews: [], // 缓存页面
    userInfo: {}, // 个人信息
    breadcrumb: [], // 面包屑
    views: [] // 多页面tag
  },
  mutations: {
    SET_TOKEN (state, data) {
      this.state.token = data;
    },
    SET_CACHED_VIEW (state, data) {
      this.state.cachedViews = data;
    },
    SET_BREADCRUMB (state, data) {
      this.state.breadcrumb = data;
    },
    SET_USER_INFO (state, data) {
      this.state.userInfo = data;
    },
    SET_VIEWS (state, data) {
      this.state.views = data;
    },
    SET_MENU (state, data) {
      this.state.menu = data;
    }
  },
  actions: {
    SetCachedViews ({ commit, state }, view) {
      return new Promise(resolve => {
        commit('SET_CACHED_VIEW', view)
        resolve([...state.cachedViews])
      })
    },
    SetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        User.getUserInfo().then(res => {
          commit('SET_USER_INFO', res)
          resolve(state.userInfo)
        }).catch(err => {
          reject(err)
        })
      })
    },
    SetMenu ({ commit, state }) {
      return new Promise((resolve, reject) => {
        User.getMyMenu().then(res => {
          const menu = res.map(item => {
            return {
              ...item,
              path: item.href,
              meta: {
                iconUrl: item.icon,
                id: item.id,
                title: item.title
              },
              children: (item.children || []).map(_item => {
                return {
                  ..._item,
                  path: _item.href,
                  meta: {
                    iconUrl: _item.icon,
                    id: _item.id,
                    title: _item.title
                  }
                }
              })
            }
          })
          commit('SET_MENU', menu)
          resolve([...state.menu])
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  modules: {
  }
})
